import { activateCheckboxes } from '../UIFunctions';

export const addPlanning = ({ state, addRemoveInfo }) => {
  activateCheckboxes();
  $('#planning_settings').show();
  $('[data-toggle="tooltip"]').tooltip({ html: true });
  $('#planning_cross')
    .off()
    .on('click', function () {
      $('#info-layer-switch').prop('checked', true);
      addRemoveInfo(null);
      addRemoveInfo(null, 'planning');
    });
  state.planningClicked = true;
  $('#info-layer-switch').prop('checked', true);
  addRemoveInfo(null);
  addRemoveInfo(null, 'planning');
};
export const addLinesearch = ({ state, addRemoveInfo }) => {
  activateCheckboxes();
  $('#lineSearch_settings').show();
  $('[data-toggle="tooltip"]').tooltip({ html: true });
  $('#lineSearch_cross')
    .off()
    .on('click', function () {
      $('#info-layer-switch').prop('checked', true);
      addRemoveInfo(null);
      addRemoveInfo(null, 'lineSearch');
    });
  state.lineSearchClicked = true;
  $('#info-layer-switch').prop('checked', true);
  addRemoveInfo(null);
  addRemoveInfo(null, 'lineSearch');
};
export const setupWFS = ({ ol, newLayer, wfsFeatureSelect }) => {
  if (!ol.controls.wfsInfo2) {
    ol.controls.wfsInfo2 = new OpenLayers.Control.SelectFeature([newLayer], {
      multiple: true,
      fallThrough: true,
    });
    ol.map.addControl(ol.controls.wfsInfo2);
    ol.controls.wfsInfo2.activate();
    ol.controls.wfsInfo2.handlers.feature.stopDown = false;
    ol.controls.wfsInfo2.layers.forEach(l => {
      l.events.fallThrough = true;
    });
    newLayer.events.fallThrough = true;
    newLayer.events.on({
      featureselected: wfsFeatureSelect,
    });
  } else {
    ol.controls.wfsInfo2.setLayer(ol.arrays.addedWFSOlLayers);
    ol.arrays.addedWFSOlLayers.forEach(l => {
      l.events.on({
        featureselected: wfsFeatureSelect,
      });
    });
  }
};
export const setupBasemap = ({ state, ol }) => {
  const l = ol.layers[state.currentBM];
  if (state.currentBM === 'aerialLayer') {
    $('div.copyright').html('©️ Getmapping Plc');
  } else {
    $('div.copyright').html('OS Copyright Licence Number is 100047514');
  }
  if (state.currentBM == 'mmLayer' || state.currentBM == 'bwLayer') ol.map.zoomTo(ol.map.getZoom());
  else ol.map.setBaseLayer(l);
};
export const addNewWFS = ({ state, ol, p, layer, colors, styles, lserver, geometryName, outputFormat }) => {
  let style;
  let styleMap;
  if (p) style = state.layerProps[p] ? state.layerProps[p].style : null;
  else style = state.layerProps[layer] ? state.layerProps[layer].style : null;
  if (style) {
    styleMap = new OpenLayers.StyleMap({
      strokeColor: style.stroke || colors.black,
      fillColor: style.fill || colors.midgrey,
      strokeWidth: style.strokeWidth || 1,
      strokeOpacity: 1,
      fillOpacity: style.fillOpacity || 0.5,
      pointRadius: 8,
    });
  } else {
    styleMap = styles.layerStyleMap;
  }

  const newLayer = new OpenLayers.Layer.Vector(layer, {
    isBaseLayer: false,
    projection: ol.osgb,
    strategies: [new OpenLayers.Strategy.BBOX()],
    protocol: new OpenLayers.Protocol.WFS({
      version: '1.1.0',
      url: lserver,
      srsName: 'EPSG:27700',
      featureType: layer,
      geometryName,
      outputFormat,
    }),
    styleMap,
    renderers: ['Canvas', 'SVG', 'VML'],
  });
  newLayer.proxy = p;
  return newLayer;
};

export const addNewWMS = ({ layer, lserver, ol, opacity, singleTile }) => {
  return new OpenLayers.Layer.WMS(
    layer,
    lserver,
    {
      layers: layer,
      transparent: true,
      cleanup: 1,
    },
    {
      format: 'image/png',
      isBaseLayer: false,
      projection: ol.osgb,
      maxExtent: [0, 0, 1400000, 1600000],
      opacity,
      singleTile,
      wrapDateLine: false,
      transitionEffect: 'resize',
    },
  );
};
